import React from "react";
import { Sparkle } from "lucide-react";
import AppShell from "@/components/AppShell";

/**
 * Iter 121 — placeholder tab for an upcoming feature. Intentionally minimal
 * and slightly mysterious; no functionality lives here yet.
 */
export default function ComingSoon() {
  return (
    <AppShell>
      <div
        className="min-h-[calc(100vh-12rem)] flex flex-col items-center justify-center px-6 -mt-8 text-center"
        data-testid="coming-soon-screen"
      >
        <div className="relative mb-8">
          <span
            aria-hidden="true"
            className="absolute inset-0 rounded-full bg-violet-300/12 blur-2xl"
          />
          <span className="relative flex items-center justify-center w-20 h-20 rounded-full border border-violet-200/25 bg-violet-200/6 backdrop-blur-md">
            <Sparkle className="w-8 h-8 text-violet-100/90" strokeWidth={1.25} data-testid="coming-soon-sparkle" />
          </span>
        </div>
        <h1
          className="font-serif-display text-3xl text-violet-50 mb-3 leading-tight"
          data-testid="coming-soon-title"
        >
          Something new is coming.
        </h1>
        <p
          className="text-sm text-violet-300/55 max-w-xs leading-relaxed"
          data-testid="coming-soon-subtitle"
        >
          We're preparing something special for you.
        </p>
      </div>
    </AppShell>
  );
}
